import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { Spinner } from '@/components/ui/spinner';

/**
 * The authentication step of the router gating chain — the outermost one. What
 * follows it is declared in one place: `GATING_CHAIN` in `router/index.tsx`.
 *
 * Nothing else is decided here. The EULA overlay used to be mounted below,
 * which made it invisible in the route table and left it exempting the
 * onboarding funnel by matching four literal paths; it is now mounted by the
 * shell layouts, so the funnel — which renders its own full-page shell — is
 * exempt by where it lives (ESCLOUD-286/288).
 */
export function AuthGuard() {
    const { isAuthenticated, isLoading } = useAuth0();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="flex h-screen w-screen items-center justify-center">
                <Spinner className="h-8 w-8" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
}
